var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoinUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-miterlimit:10;}.a,.b{stroke:#fff;stroke-width:2px;}.b{fill:url(#a);}.c{fill:#fff;}.d{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#009873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ea74"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-934.887 -51.709)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 37.5,
    cy: 37.5,
    rx: 37.5,
    ry: 37.5,
    transform: "translate(934.887 51.709)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(934.887 51.709)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -10, -7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M37.5,0A37.5,37.5,0,1,1,0,37.5,37.5,37.5,0,0,1,37.5,0Z",
    transform: "translate(10 7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.099 15.638)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M971.66,52.768H944.59a2.866,2.866,0,0,0-2.866,2.866V93.394a2.864,2.864,0,0,0,2.866,2.866h27.07a2.859,2.859,0,0,0,2.847-2.548,2.769,2.769,0,0,0,.019-.319V55.634A2.865,2.865,0,0,0,971.66,52.768Zm-2.866,37.76H947.456V58.5h21.338Z",
    transform: "translate(-941.724 -52.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M967.328,77.773a1.58,1.58,0,0,1-.166.7v0a1.592,1.592,0,0,1-1.427.885H953.486a1.592,1.592,0,1,1,0-3.184h12.249a1.587,1.587,0,0,1,1.574,1.363v.01A1.3,1.3,0,0,1,967.328,77.773Z",
    transform: "translate(-943.066 -55.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M967.3,68.22a1.592,1.592,0,0,1-1.593,1.592h-12.46a1.592,1.592,0,0,1,0-3.184H965.7A1.591,1.591,0,0,1,967.3,68.22Z",
    transform: "translate(-943.034 -54.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M967.328,87.326a1.575,1.575,0,0,1-.143.659,1.591,1.591,0,0,1-1.389.931.473.473,0,0,1-.061,0H953.486a1.592,1.592,0,1,1,0-3.184h12.249a1.586,1.586,0,0,1,1.551,1.229A1.7,1.7,0,0,1,967.328,87.326Z",
    transform: "translate(-943.066 -57.119)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinUs);
export default __webpack_public_path__ + "static/media/join-us.e2e7aa572509e45c2a60214e8223e968.svg";
export { ForwardRef as ReactComponent };